import { render, staticRenderFns } from "./IasonLogoSvg.vue?vue&type=template&id=74f3b87c"
import script from "./IasonLogoSvg.vue?vue&type=script&lang=js"
export * from "./IasonLogoSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports